// @angular
import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
// Own services
import { SessionDataService } from "../../../services/shared/SessionDataService.service";
import { DragElementService } from "../../../services/shared/DragElementService.service";
// Interfaces
import { Task } from "./request-progress-task-interface";
import { TranslateModule } from "@ngx-translate/core";
import { NgClass, DecimalPipe } from "@angular/common";
import { Router } from "@angular/router";

/**
 * Expandable panel listing in-progress background tasks from SessionDataService.wip.
 * Selecting a task restores its agrupation or entity context and navigates to its progress table.
 */
@Component({
  selector: "app-request-progress-panel",
  templateUrl: "./request-progress-panel.component.html",
  styleUrls: ["./request-progress-panel.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, DecimalPipe, TranslateModule]
})
export class RequestProgressPanelComponent {
  /***************************************************************************/
  // ANCHOR Variables
  /***************************************************************************/

  private readonly router = inject(Router);
  readonly SessionDataService = inject(SessionDataService);
  readonly DragElementService = inject(DragElementService);
  readonly wip = this.SessionDataService.wip.asReadonly();
  panelExpanded = signal<boolean>(true);

  /***************************************************************************/
  // ANCHOR Functions
  /***************************************************************************/

  // Redirect to the progress table
  goToProgressTable(task: Task): void {
    if (task.agrupation) {
      this.SessionDataService.sendAvoidNavigationReload(true);
      this.SessionDataService.sendAgrupation(task.agrupation);
    } else if (task.entity) {
      this.SessionDataService.sendAvoidNavigationReload(true);
      this.SessionDataService.sendEntity(task.entity);
    }
    this.router.navigate([task.url + "/" + task.taskIndex], {
      state: { data: task.taskIndex },
    });
  }
}
